// import logo from './logo.svg';
import './App.css';
import './index.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import TestApi from './components/TestApi';
import { AuthContextProvider, useAuth } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';

//pages & components
import CreateRecipe from './pages/CreateRecipe';
import CreateIngredient from './pages/CreateIngredient';
import RecipeList from './pages/RecipeList';
import IngredientList from './pages/IngredientList';
import IngredientDetails from './pages/IngredientDetails';
import IngredientEdit from './pages/IngredientEdit';
import RecipeDetails from './pages/RecipeDetails';
import RecipeEdit from './pages/RecipeEdit';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import LandingPage from './pages/LandingPage';
import LandingPage2 from './pages/LandingPage2';
import LandingPage3 from './pages/LandingPage3';
import LandingPage4 from './pages/LandingPage4';
import CuisinePage from './pages/CuisinePage';
import PantryIngredientsList from './pages/PantryIngredientsList';
import MealPlanPage from './pages/MealPlanPage';
import ExploreRecipesPage from './pages/ExploreRecipesPage';
import DynamicExploreRecipes from './components/DynamicExploreRecipes';
import RecipesForDiet from './pages/RecipesForDiet';
import RecipesForCuisine from './pages/RecipesForCuisine';
import RecipeSteps from './pages/RecipeSteps';
import Signup from './components/Signup';
import Signin from './components/Signin';
import UserSetup from './pages/UserSetup';
import PricingPage from './pages/PricingPage';
import AuthLoadingPage from './pages/AuthLoadingPage';
import UserPreferences from './pages/UserPreferences';
import RecipesForFoodType from './pages/RecipesForFoodType';
import MealSteps from './pages/MealSteps';
import ProfilePage from './pages/ProfilePage';
import PasswordReset from './pages/PasswordReset';
import PasswordUpdate from './components/PasswordUpdate';
import EmailConfirmation from './pages/EmailConfirmation';
import MyRecipesPage from './pages/MyRecipesPage';
import RecipesForTag from './pages/RecipesForTag';
import RecipesForIngredients from './pages/RecipesForIngredients';
import PantryAndGroceries from './pages/PantryAndGroceries';
import PantryAndGroceriesWithSimpleButtons from './pages/PantryAndGroceriesWithSimpleButtons';
import MyGroceryList from './pages/MyGroceryList';
import MyGroceryListAdjustable from './pages/MyGroceryListAdjustable';
import WaitlistPage from './pages/WaitlistPage';
import Home from './pages/Home';
import ImportRecipeFromUrl from './pages/ImportRecipeFromUrl';
import DietCoverageDashboard from './pages/DietCoverageDashboard';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';


// Protected route component
const ProtectedRoute = ({ children }) => {
  const { user, pgUser, loading } = useAuth();
  
  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  if (pgUser !== null && pgUser !== undefined && !pgUser.email_confirmed) {
    return <Navigate to="/email-confirmation" />;
  }
  return children;
};

// Wrapper component to handle conditional navbar rendering
const AppContent = () => {
  const location = useLocation();
  const { user, pgUser, loading } = useAuth();
  
  const showNavbar = location.pathname !== '/' && location.pathname !== '/pricing' && location.pathname !== '/waitlist' && location.pathname !== '/privacy-policy' && location.pathname !== '/terms' && location.pathname !== '/contact' && location.pathname !== '/support';
  


  return (
    <>
      {showNavbar && <Navbar />}
      <div className="pages">
        <Routes>
          <Route path="/" element={<LandingPage4 />} />
          <Route path="/landing-page-2" element={<LandingPage2 />} />
          <Route path="/landing-page-3" element={<LandingPage3 />} />
          <Route path="/landing-page-4" element={<LandingPage4 />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/support" element={<ContactPage />} />
          <Route path="/create-recipe" element={
            <ProtectedRoute>
              <CreateRecipe />
            </ProtectedRoute>
          } />
          <Route path="/create-ingredient" element={
            <ProtectedRoute>
              <CreateIngredient />
            </ProtectedRoute>
          } />
          <Route path="/cuisine/:cuisineName" element={<RecipesForCuisine />} />
          <Route path="/diet/:dietName" element={<RecipesForDiet />} />
          <Route path="/food-type/:foodTypeName" element={<RecipesForFoodType />} />
          <Route path="/tag/:tagName" element={<RecipesForTag />} />
          <Route path="/recipes/search-by-ingredients" element={
            <ProtectedRoute>
              <RecipesForIngredients />
            </ProtectedRoute>
          } />
          <Route path="/ingredients" element={<IngredientList />} />
          <Route path='/ingredients/:ingredientId' element={<IngredientDetails />} />
          <Route path="/ingredients/:ingredientId/edit" element={
            <ProtectedRoute>
              <IngredientEdit />
            </ProtectedRoute>
          } />
          <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/meal-plan" element={
            <ProtectedRoute>
              <MealPlanPage />
            </ProtectedRoute>
          } />
          <Route path="/recipes" element={
            <ProtectedRoute>
              <DynamicExploreRecipes />
            </ProtectedRoute>
          } />
          <Route path="/recipes/all" element={
            <ProtectedRoute>
              <RecipeList />
            </ProtectedRoute>
          } />
          <Route path="/recipes/saved" element={
            <ProtectedRoute>
              <MyRecipesPage />
            </ProtectedRoute>
          } />
          {/* <Route path="/recipes/:recipeId/instructions" element={<RecipeDetails />} /> */}
          <Route path="/recipes/:recipeId/steps" element={<RecipeSteps />} />
          {/* <Route path="/meals/:mealId/steps" element={<MealSteps />} /> */}
          <Route path="/recipes/:recipeId/edit" element={
            <ProtectedRoute>
              <RecipeEdit />
            </ProtectedRoute>
          } />
          <Route path="/pantry" element={
            <ProtectedRoute>
              <PantryIngredientsList />
            </ProtectedRoute>
          } />
          <Route path="/pantry-and-groceries-advanced" element={
            <ProtectedRoute>
              <PantryAndGroceries />
            </ProtectedRoute>
          } />
          <Route path="/pantry-and-groceries" element={
            <ProtectedRoute>
              <PantryAndGroceriesWithSimpleButtons />
            </ProtectedRoute>
          } />
          <Route path="/preferences" element={
            <ProtectedRoute>
              <UserPreferences />
            </ProtectedRoute>
          } />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Signin />} />
          <Route path="/email-confirmation" element={<EmailConfirmation />} />
          <Route path="/setup" element={<UserSetup />} />
          <Route path="/auth-loading" element={<AuthLoadingPage />} />
          <Route path="/profile" element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          } />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/password-update" element={<PasswordUpdate />} />
          <Route path="/grocery-list" element={<MyGroceryListAdjustable />} />
          <Route path="/admin/import-recipe" element={
            <ProtectedRoute>
              <ImportRecipeFromUrl />
            </ProtectedRoute>
          } />
          <Route path="/admin/diet-coverage" element={
            <ProtectedRoute>
              <DietCoverageDashboard />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
      <BottomNav />
    </>
  );
};

const RouteValidator = ({ children }) => {
  const location = useLocation();
  const { user, pgUser, loading } = useAuth();
  
  // Handle manual URL changes
  useEffect(() => {
    if (!loading && user && pgUser) {
      // Validate if user can access current route
      // Redirect if necessary
    }
  }, [location.pathname, user, pgUser, loading]);
  
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <AuthContextProvider>
        <div className="App">
          <BrowserRouter>
            <RouteValidator>
              <AppContent />
            </RouteValidator>
          </BrowserRouter>
        </div>
      </AuthContextProvider>
    </ErrorBoundary>
  );
}

export default App;
